import { render } from "./questionThree.vue?vue&type=template&id=0b87b902"
import script from "./questionThree.vue?vue&type=script&lang=js"
export * from "./questionThree.vue?vue&type=script&lang=js"

import "./questionThree.vue?vue&type=style&index=0&id=0b87b902&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__